import Vue from 'vue';
import VueChatScroll from 'vue-chat-scroll';
import Vuelidate from 'vuelidate';
import { VueMaskDirective } from 'v-mask'

Vue.use(VueChatScroll);
Vue.use(Vuelidate);
Vue.directive('mask', VueMaskDirective);
